import { FC, useState } from "react";
import cn from "classnames/bind";

import { TableOfContentsProps } from "./TableOfContents.types";
import styles from "./TableOfContents.module.scss";

const cx = cn.bind(styles);

export const TableOfContents: FC<TableOfContentsProps> = ({
    headings = [],
    className,
}) => {
    const [activeItem, setActiveItem] = useState<null | string>(null);

    const handleClick = (link?: string) => () => {
        if (link) {
            setActiveItem(link);
        }
    };

    return headings?.length > 0 ? (
        <div className={cx("root", className)}>
            <div className={cx("container")}>
                {headings.map(({ link, name }) => (
                    <a
                        className={cx("heading", {
                            heading_active: activeItem === link,
                        })}
                        href={link}
                        onClick={handleClick(link)}
                        key={link}
                    >
                        {name}
                    </a>
                ))}
            </div>
        </div>
    ) : null;
};
